export default __webpack_public_path__ + "static/media/b51.4020f500.png";